import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.tsx";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppProvider } from "./contexts";
import { persister, queryClient } from "./config";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "react-datepicker/dist/react-datepicker.css";
import "./scss/main.scss";

ReactDOM.createRoot(document.getElementById("root") ?? document.createElement("div")).render(
    // <React.StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
        <BrowserRouter>
            <AppProvider>
                <Routes>
                    <Route path="*" element={<App />} />
                </Routes>
            </AppProvider>
        </BrowserRouter>
        {import.meta.env.DEV && <ReactQueryDevtools />}
    </PersistQueryClientProvider>
    // </React.StrictMode>
);
